import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route,  Switch } from 'react-router-dom'
import Recommand from "../pages/Recommand";
import CouponDeliveryConfirm from '../pages/CouponDeliveryConfirm';
import PagenotFound from './PagenotFound';
import WebviewLayout from '../pages/WebviewLayout';
import {About, Company, Introduction} from '../pages/company';
import {Home, PostCode, Terms, VerifyHome} from '../pages';
import {BoardList, BoardWrite} from '../pages/boards';
import {
    CouponcodeVerify,
    CouponVerifyConfig,
    CouponVerifyIssue,
    CouponVerifyList,
    CouponVerifyUsed
} from '../pages/verifications';
import AppleLoginComponent from "../pages/auth/AppleLogin";
import AppleCallback from "../pages/auth/AppleCallback";
import TourCertificationComponent from '../pages/coupons/TourCertification'
import MoveUrlComponent from '../pages/MoveUrl';
import {
    Verification2Config,
    Verification2t1,
    Verification2t2,
    Verification2t3,
    Verification2t4, Verification2t5
} from '../pages/verification2';
import {Verify2Home} from '../pages/Verify2';
import {RnPostCode} from '../pages/rn';
import { Ho } from '../pages/survey'
import HoEnd from '../pages/survey/hoEnd'
import Promotion from '../pages/promotion/promotion'
import { URLSearchParams } from 'url'
import * as queryString from 'query-string'
import PlayqLoginComponent from '../pages/auth/PlayqLogin'
import { Withdrawal } from '../pages/members'
import StampixLoginComponent from '../pages/auth/StampixLogin'

if (process.env.REACT_APP_VAR !== 'development') {
    console.log = function no_console() {
    };
}

const App = () => {

        useEffect(()=>{
           console.log('App loaded');
        });
        return (
            <Router>
                <WebviewLayout>
                    <Switch>
                        <Route exact path="/" component={Home}/>
                        <Route path="/coupons/recom" component={Recommand}/>
                        <Route path="/coupons/tour/certification" component={TourCertificationComponent}/>
                        <Route path="/coupons/delivery/confirm/:id" component={CouponDeliveryConfirm}/>
                        <Route path="/postcode" component={PostCode}/>
                        <Route path="/rn/postcode" component={RnPostCode}/>
                        <Route path="/company/about" component={About}/>
                        <Route path="/company/introduction" component={Introduction}/>
                        <Route path="/company" component={Company}/>
                        <Route path="/terms/:id" component={Terms}/>
                        <Route path="/terms" component={Terms}/>
                        <Route path="/boards/write/:id" component={BoardWrite}/>
                        <Route path="/boards/:id/:category" component={BoardList}/>
                        <Route path="/boards/:id" component={BoardList}/>
                        <Route path="/boards" component={BoardList}/>
                        <Route path="/verifications" component={VerifyHome} exact/>
                        <Route path="/verifications/coupon/config" component={CouponVerifyConfig}/>
                        <Route path="/verifications/coupon/code" component={CouponcodeVerify}/>
                        <Route path="/verifications/coupon/issue" component={CouponVerifyIssue}/>
                        <Route path="/verifications/coupon/used" component={CouponVerifyUsed}/>
                        <Route path="/verifications/coupon/list" component={CouponVerifyList}/>
                        <Route path="/apple/login" component={AppleLoginComponent}/>
                        <Route path="/apple/playq/login" component={PlayqLoginComponent}/>
                        <Route path="/apple/callback" component={AppleCallback}/>
                        <Route path={'/url'} component={MoveUrlComponent}/>
                        <Route path="/verification2" component={Verify2Home} exact/>
                        <Route path="/verification2/config" component={Verification2Config}/>
                        <Route path="/verification2/t1" component={Verification2t1}/>
                        <Route path="/verification2/t2" component={Verification2t2}/>
                        <Route path="/verification2/t3" component={Verification2t3}/>
                        <Route path="/verification2/t4" component={Verification2t4}/>
                        <Route path="/verification2/t5" component={Verification2t5}/>
                        <Route path="/survey/Hoguk" component={Ho}/>
                        <Route path="/survey/hogukResult" component={HoEnd}/>
                        <Route path="/promotion" component={Promotion}/>
                        <Route path="/members/withdrawal" component={Withdrawal}/>
                        <Route path="/apple/stampix/login" component={StampixLoginComponent}/>
                        <Route path='*' component={PagenotFound}/>
                    </Switch>
                </WebviewLayout>
            </Router>
        );
}

export default App;
